import { mapGetters } from 'vuex'

export default {
    data: () => ({
        access: [2,3,4,30,38]
    }),
    created: function () {

    },
    computed: {
        ...mapGetters({
            user: 'auth/user',
        }),
        userRole() {
            if(this.user != null && this.user.roles.length) {
                return this.user.roles[0].name
            } else {
                return ''
            }
        },
        userRoles() {
            let arr = [];

            this.user.roles.forEach(role => {
                arr.push(role.name);
            })

            return arr
        }
    },
    methods: {
        ifInArray(value) {
            return this.userRoles.indexOf(value) > -1 ? true : false
        }
    }
 }